import * as React from 'react'

import { Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface ImportFileValidation {
  type: string
  description: string
  rows: string[]
}

interface Props {
  errors: ImportFileValidation[]
}

const ImportErrorsTable: React.FC<Props> = ({ errors }) => {
  const content = errors.map(({ type, description, rows }, i) => {
    const rows_content = rows.map((row, i) => {
      const trailingComma = i !== rows.length - 1 ? ', ' : ''

      return `${row}${trailingComma}`
    })

    return (
      <Table.Row key={i}>
        <Table.Cell>
          <Text.Normal weight="medium">{type}</Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <Text.Normal weight="medium">{description}</Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <Text.Normal weight="medium">{rows_content}</Text.Normal>
        </Table.Cell>
      </Table.Row>
    )
  })

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>{i18n.t('job_catalog.import_errors_page.table.type')}</Table.HeadCell>
          <Table.HeadCell>
            {i18n.t('job_catalog.import_errors_page.table.description')}
          </Table.HeadCell>
          <Table.HeadCell>
            {i18n.t('job_catalog.import_errors_page.table.conflictive_rows')}
          </Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>{content}</Table.Body>
    </Table>
  )
}

export default ImportErrorsTable
